import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { Filter, Main } from 'Containers/';
import { StudentLookupGrid } from 'Common/Components/StudentLookupGrid/StudentLookupGrid';
import { fetchStudents, replaceMember } from '../state/studentlookup/actions';
import { ApplicationFieldEnum as Fields } from 'Common/FieldEnum';

class StudentReplacementLookupContainer extends Component {
  static path = '/reviewincomingapplications/studentlookup/:memberId';

  state = {
    disabledStudents: [],
  };

  componentDidMount() {
    const {
      match: {
        params: { memberId },
      },
    } = this.props;
    var disabledStudents = [];

    if (this.props.applicationData.length === 0) {
      this.props.history.push(this.getRootUrl());
      return;
    }

    this.props.applicationData.forEach(app => {
      app.Members.forEach(member => {
        if (member.Id !== parseInt(memberId, 10)) {
          disabledStudents.push(member.MemberStudentNumber);
        }
      });
    });

    this.setState({ disabledStudents });
  }

  fetchData = ({ page, filtered, sorted }, showWithdrawn) => {
    this.props.fetchStudents(page, filtered, sorted, showWithdrawn);
  };

  onSelect = student => {
    const {
      match: {
        params: { memberId },
      },
    } = this.props;
    this.props.replaceMember(memberId, student);
    this.props.history.push(this.getRootUrl());
  };

  getRootUrl = () => {
    const { url } = this.props.match;
    return url.substring(0, url.lastIndexOf('/studentlookup'));
  };

  getMainProps = () => {
    return {
      toolbox: {
        backButtonProps: { shown: true, path: this.getRootUrl() },
        shown: true,
      },
    };
  };

  render() {
    const {
      loading,
      totalPages,
      students,
      match: {
        params: { memberId },
      },
    } = this.props;
    const { disabledStudents } = this.state;

    var member = null;
    this.props.applicationData.forEach(app => {
      const foundMember = app.Members.find(
        member => member.Id === parseInt(memberId, 10)
      );
      member = foundMember ? foundMember : member;
    });

    return (
      <Fragment>
        <Filter title={'Review Incoming Applications'} />
        <Main {...this.getMainProps()}>
          <label className={'text-orange'}>Student Lookup</label>
          <StudentLookupGrid
            loading={loading}
            onFetchData={this.fetchData}
            onSelect={this.onSelect}
            students={students}
            disabledStudents={disabledStudents}
            totalPages={totalPages}
            showWithdrawn={true}
            defaultFilter={[
              {
                id: Fields.FirstName,
                value: member ? member.MemberFirstName.charAt(0) : '',
              },
              {
                id: Fields.LastName,
                value: member ? member.MemberLastName : '',
              },
            ]}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    ReviewIncomingApplicationsState: { studentLookup, grid },
  } = state;

  return {
    loading: studentLookup.fetching,
    students: studentLookup.students,
    applicationData: grid.applicationData,
    totalPages: studentLookup.totalPages,
  };
};

export const StudentReplacementLookup = withRouter(
  connect(
    mapStateToProps,
    {
      fetchStudents,
      replaceMember,
    }
  )(StudentReplacementLookupContainer)
);



// WEBPACK FOOTER //
// ./src/pages/reviewincomingapplications/subpages/StudentReplacementLookup.js